import { render, staticRenderFns } from "./RcpyES_Details.vue?vue&type=template&id=021adfb4"
import script from "./RcpyES_Details.vue?vue&type=script&lang=js"
export * from "./RcpyES_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports